import { getQFromQuery } from '../../utils'
import { ClusteringKMeansSettingsQueryParams } from '../types'

export const generateQuery = ({ geomField, clusters, baseQuery, atLocation }: ClusteringKMeansSettingsQueryParams) => {
  const lastQuery = getQFromQuery(baseQuery) || 1
  const clusteringQquery = `\tWITH clustering AS (
\t\tSELECT
\t\t\t${atLocation}.ST_CLUSTERKMEANS(ARRAY_AGG(ST_ASGEOJSON(${geomField})::STRING), ${clusters}) AS clusters
\t\tFROM
\t\t\t__q${lastQuery}
\t\tWHERE
\t\t\t${geomField} IS NOT NULL
\t)
\tSELECT
\t\tGET(VALUE, 'cluster')::STRING AS cluster,
\t\tTO_GEOGRAPHY(GET(VALUE, 'geom')) AS geom
\tFROM
\t\tclustering, lateral FLATTEN(input => clusters)`
  const query = `${baseQuery},
__q${lastQuery + 1} AS (
${clusteringQquery}
)
SELECT * FROM __q${lastQuery + 1}`
  return query
}
